export default __webpack_public_path__ + "static/media/O-040.252ddcf7.png";